import { useTranslation } from "next-i18next";
import Link from "next/link";

export default function ErrorScreen() {
	const { t } = useTranslation("common");

	return (
		<section className="error-page">
			<img src="/error.webp" alt="" />
			<div className="error-page__conetnt">
				<h2>404</h2>
				<p>{t("page404.title")}</p>
				<Link href="/">
					<button className="btn cloud" type="button">
						{t("page404.back")}
					</button>
				</Link>
			</div>
		</section>
	);
}
